import React from "react";
import { useNavigate } from "react-router-dom";
import "../Support/Support.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaPlaneDeparture,
  FaHeadset,
} from "react-icons/fa";

const Support = () => {
  const navigate = useNavigate();

  const handleCall = () => {
    window.location.href = "tel:+1800123456";
  };

  const handleEmail = () => {
    window.location.href = "mailto:support@abc.com";
  };

  const handleSupport = () => {
    navigate("/support");
  };

  const handleCallback = () => {
    navigate("/contactus");
  };

  return (
    <section className="abc-support">
      <div className="abc-support-header">
        <h2>Need Help with Your Flight?</h2>
        <p>
          Abc.com airline experts are available 24/7 to help with flight
          bookings, cancellations, rescheduling and exclusive airfare deals.
        </p>
      </div>

      <div className="abc-support-grid">
        <div className="abc-support-card" onClick={handleCall}>
          <div className="abc-icon">
            <FaPhoneAlt />
          </div>
          <h3>Call Us</h3>
         
          <p>Speak directly on +1 800 123 456 with our specialists</p>
        </div>

        <div className="abc-support-card" onClick={handleEmail}>
          <div className="abc-icon">
            <FaEnvelope />
          </div>
          <h3>Email Support</h3>
          <p>Send your flight enquiry anytime</p>
        </div>

        <div className="abc-support-card" onClick={handleSupport}>
          <div className="abc-icon">
            <FaPlaneDeparture />
          </div>
          <h3>Flight Assistance</h3>
          <p>Booking • Changes • Refunds</p>
        </div>

        <div className="abc-support-card" onClick={handleCallback}>
          <div className="abc-icon">
            <FaHeadset />
          </div>
          <h3>Request Callback</h3>
          <p>Our travel expert will contact you</p>
        </div>
      </div>
    </section>
  );
};

export default Support;
